<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>
<script>
import {mapGetters} from "vuex";
import GoogleTagManager from "./assets/js/pixel-manager/GoogleTagManager";

export default {
  methods: {
    ...mapGetters(['getLanguage']),
    loadCSSAsync(url) {
      return new Promise(function (resolve, reject) {
        let link = document.createElement('link');
        link.href = url;
        link.rel = 'stylesheet';
        link.onload = resolve;
        link.onerror = reject;

        let head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(link);
      });
    }
  },
  beforeMount() {
    this.loadCSSAsync('https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css')
    //this.loadCSSAsync('https://fonts.googleapis.com/css2?family=Cairo&display=swap')
    this.$vuetify.rtl = this.getLanguage()?.rtl ?? false
    this.$i18n.locale = this.getLanguage()?.language ?? false

    GoogleTagManager.init().pageView({title: 'app visited'})
  }
}
</script>
<style lang="scss">
//@import "~bootstrap/dist/css/bootstrap.css";
//@import "assets/css/font.css";

@import "assets/css/demo.css";
@import "assets/css/custom.css";

$bg-color: #363740;
$mcn-blue: var(--app-secondary-color);

:root {
  --app-color: #252733;
  //--app-secondary-color: #0073c0;
  --mcn-primary-color: #02b3aa;
  --mcn-secondary-color: #02f5e8;
  --app-primary-color: var(--v-primary-base);
  --app-primary_rgb-color: var(--v-primary_rgb-base);
  --app-base-color: var(--v-base-base);
  --app-border-color: var(--v-border-base);
  --app-secondary-color: var(--v-secondary-base);
  --app-accent-color: var(--v-accent-base);
  --app-info-color: var(--v-info-base);
  --app-success-color: var(--v-success-base);
  --app-warning-color: var(--v-warning-base);
  --app-fire-color: var(--v-fire-base);
  --app-light-hover-color: var(---v-lighthover-base);
}

.drafted_input > .v-input__control fieldset {
  border-color: var(--app-warning-color) !important;
}

.drafted_input > .v-input__control .v-label {
  color: var(--app-warning-color) !important;
}

.drafted_input > .v-input__control input {
  caret-color: var(--app-warning-color) !important;
}

.app-secondary-color {
  color: var(--app-secondary-color);
}

// to make space between vuetify inputs inner icon and input field
.v-input__slot {
  gap: 5px;
}

.step-color {
  color: var(--app-secondary-color);
}

html {
  overflow: auto !important;

  & * {
    word-break: keep-all;
  }
}

* {
  box-sizing: border-box;
  font-family: 'Cairo', sans-serif;
}

.v-application .v-list-item {
  .v-list-item__title {
    line-height: 1.4 !important;
  }

  .v-list-item__subtitle {
    line-height: 1.3 !important;
  }

}

body {
  font-size: 14px !important;
  background-color: #F7F8FC;
}

.app-bg-color {
  background-color: #F7F8FC !important;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-grab {
  cursor: pointer;
}

.invalid-input {
  border: 1px solid darkred !important;
}

.danger-message {
  color: red !important;
}

.app-color {
  color: #252733;
}

.v-messages__message {
  line-height: 1.5 !important;
}

.v-list-item__title {
  text-align: start !important;
}

.one-line-row .v-data-table td {

  white-space: nowrap;

  & > span {
    display: inline-block;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
